import { connect } from 'react-redux'
// For Lifecycle composing
import { compose, lifecycle } from 'recompose'
import ShortUrl, {
  Values,
  Callbacks
} from '../../components/shortUrl/shortUrlComponent'
import { State } from '../../redux/reducers/'
import { actionCreators as sagaActions } from '../../redux/sagas/'
import { actionCreators } from '../../redux/reducers/ui/uiReducer'

// Global State
export function mapStateToProps (state: State, props): Values {
  return {
    shortUrl: state.ui.shortUrl,
    plan: state.gradPlanner.plan
  }
}
// In Object form, each funciton is automatically wrapped in a dispatch
export const propsMapping: Callbacks = {
  getShortUrl: sagaActions.shortUrlActionCreators.getShortUrl
}

// If you want to use the function mapping
// export const propsMapping = (dispatch, ownProps) => {
//   return {
//     onClick: () => dispatch(actions.starsActions.FETCH_STARS)
//   }
// }

// export default connect(mapStateToProps, propsMapping)(ShortUrl)

export default compose(
  connect(mapStateToProps, propsMapping),
  lifecycle({
    componentDidMount: function () {
      if (this.props.getShortUrl) {
        this.props.getShortUrl(this.props.plan)
      }
    }
  })
)(ShortUrl)



// WEBPACK FOOTER //
// ./src/containers/shortUrl/shortUrlContainer.js